import { FC, useEffect, useMemo, useState } from 'react'
import cn from './index.module.css'
import Preloader from '@UI/Preloader'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import { favoriteCourseSort, fetchMyCoursesOrders } from './utils/api'
import MyCoursesList from '@pages/CoursesCatalog/components/MyCoursesList/MyCoursesList'
import rolesEnum from '@/constant/rolesEnum'
import { directionAPI } from '@/api'

interface IMyCoursesTab {}

const MyCoursesTab: FC<IMyCoursesTab> = ({}) => {
  const user = useSelector(selectProfile)
  const [isLoading, setIsLoading] = useState(true)
  const [courses, setCourses] = useState<ICourseOrder[]>([])

  useEffect(() => {
    async function fetchForChildren() {
      setIsLoading(true)
      const courses = await fetchMyCoursesOrders(user.id)
      setCourses(courses)
      setIsLoading(false)
    }
    
    if(user.role !== rolesEnum.seniorSeminarian){
      fetchForChildren()
    }
    
    function fetchForEmployee() {
      setIsLoading(true)
      directionAPI.overview().then(({ data }) => {
        if(data.status === 'success'){

          const courses = (data?.data ?? [])?.map((course: any) => (
              {
                direction_id: course.id,
                direction: {
                  name: course.name,
                  id: course.id,
                  icon_path: course.icon_path
                }
              }
            )
          )
          setCourses(courses) 

        }
      })
      .finally(() => setIsLoading(false))
    }
    
    if(user.role === rolesEnum.seniorSeminarian){
      fetchForEmployee()
    }

  }, [user.role, user.id])

  const onFavoriteChange = (order: ICourseOrder) => {
    const favorite = order?.favorite === 1 ? 0 : 1

    setCourses((prev) =>
      prev
        .map((item) =>
          item?.direction_id === order?.direction_id
            ? { ...item, favorite }
            : item,
        )
        .sort(favoriteCourseSort),
    )
  }

  return (
    <div className={cn.wrapper}>
      {isLoading ? (
        <div className={cn.courseListLoadingStub}>
          <Preloader />
        </div>
      ) : (
        <MyCoursesList courses={courses} onFavoriteChange={onFavoriteChange} />
      )}
    </div>
  )
}

export default MyCoursesTab
